/* __next_internal_client_entry_do_not_use__ useSearchPageQueryParams auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { getDoQuerySpellcheckGivenRecordOfQueryParams, getFilterKeysGivenRecordOfQueryParams, getPageNumberGivenRecordOfQueryParams, getRefReqIdGivenRecordOfQueryParams, getRefTypeGivenRecordOfQueryParams, getSearchQueryGivenRecordOfQueryParams } from "@faire/retailer-shared/search/searchRequest";
import { useSearchPageParsedSearch } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageParsedSearch";
import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { QueryParameters } from "@faire/web-api--source/routes/www/search/";
import qs from "query-string";
import { useEffect, useMemo, useRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
// Temporarily disabled to figure out regression in UPLT in MILLION_LINT_OPTIMIZATION_241118
var getSettingAndAssignMillionLintOptimizationUseLocation = function() {
    return false;
};
export var useSearchPageQueryParams = function() {
    var shouldMemoMillionLint = getSettingAndAssignMillionLintOptimizationUseLocation();
    var pathname = useLocation().pathname;
    var history = useHistory();
    var queryParams = useQueryParams(QueryParameters.parse);
    var updateQueryParamsAndStringify = useUpdateQueryParamsAndStringify(queryParams);
    var parsedSearch = useSearchPageParsedSearch();
    return useMemo(function() {
        var searchQuery = getSearchQueryGivenRecordOfQueryParams(parsedSearch);
        var filters = getFilterKeysGivenRecordOfQueryParams(parsedSearch);
        var zeroIndexedPageNumber = getPageNumberGivenRecordOfQueryParams(parsedSearch);
        var referrerType = getRefTypeGivenRecordOfQueryParams(parsedSearch);
        var doQuerySpellCheck = getDoQuerySpellcheckGivenRecordOfQueryParams(parsedSearch);
        var refReqId = getRefReqIdGivenRecordOfQueryParams(parsedSearch);
        var setFilters = function(updater) {
            var clearZeroIndexedPageNumber = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var updatedFilterKeys = updater(filters);
            var queryString = updateQueryParamsAndStringify(function(oldParams) {
                return _object_spread_props(_object_spread({}, oldParams), {
                    filters: updatedFilterKeys.length === 0 ? undefined : updatedFilterKeys.join(","),
                    ps: undefined,
                    page: clearZeroIndexedPageNumber ? undefined : oldParams.page,
                    fc: true
                });
            });
            history.push({
                pathname: pathname,
                search: queryString
            });
        };
        var clearFilters = function() {
            setFilters(function() {
                return [];
            });
        };
        return {
            searchQuery: searchQuery,
            filters: filters,
            setFilters: setFilters,
            clearFilters: clearFilters,
            zeroIndexedPageNumber: zeroIndexedPageNumber,
            referrerType: referrerType,
            doQuerySpellCheck: doQuerySpellCheck,
            refReqId: refReqId
        };
    }, /* eslint-disable-next-line react-compiler/react-compiler */ /* eslint-disable react-hooks/exhaustive-deps */ shouldMemoMillionLint ? [
        history,
        pathname,
        updateQueryParamsAndStringify,
        parsedSearch.q,
        parsedSearch.category,
        parsedSearch.filter,
        parsedSearch.filters,
        parsedSearch.page,
        parsedSearch.refReqId,
        parsedSearch.refType,
        parsedSearch.view,
        parsedSearch.product,
        parsedSearch.brand,
        parsedSearch.signUp,
        parsedSearch.refS
    ] : [
        history,
        parsedSearch,
        pathname,
        updateQueryParamsAndStringify
    ]);
};
var useUpdateQueryParamsAndStringify = function(queryParams) {
    var queryParamsInMemory = useRef(queryParams);
    useEffect(function() {
        queryParamsInMemory.current = queryParams;
    }, [
        queryParams
    ]);
    return useCallback(function(updater) {
        queryParamsInMemory.current = updater(queryParamsInMemory.current);
        return qs.stringify(queryParamsInMemory.current);
    }, []);
};
